import { http, HttpResponse } from 'msw'

import { allPlanograms } from 'app/mocks/data/machines/planograms'

import {
    api,
    isNumeric,
    queryIntoArrayNumber,
    SEARCH_PARAM_LIMIT,
    SEARCH_PARAM_OFFSET,
} from 'app/utils/constants'

export const getAllPlanograms = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.machines.planograms.LIST}`,
    ({ request }) => {
        const { searchParams } = new URL(request.url)
        const limitQuery = searchParams.get(SEARCH_PARAM_LIMIT)
        const offsetQuery = searchParams.get(SEARCH_PARAM_OFFSET)

        const managersQuery = searchParams.get('machine__site__client__id__in')

        const clientsQuery = searchParams.get(
            'machine__site__customer_name__id__in',
        )

        const sitesQuery = searchParams.get('machine__site__id__in')
        const machineTypeQuery = searchParams.get('machine__category__in')
        const nameQuery = searchParams.get('name__icontains')
        const statusQuery = searchParams.get('status')

        let allPlanogramsFiltered = allPlanograms

        // Manager filter
        if (managersQuery) {
            const managerIdsSplit = queryIntoArrayNumber(managersQuery)

            allPlanogramsFiltered = allPlanogramsFiltered.filter((planogram) =>
                managerIdsSplit.includes(
                    planogram.machine.site.customer_name.client.id,
                ),
            )
        }

        // Client filter
        if (clientsQuery) {
            const clientIdsSplit = queryIntoArrayNumber(clientsQuery)

            allPlanogramsFiltered = allPlanogramsFiltered.filter((planogram) =>
                clientIdsSplit.includes(
                    planogram.machine.site.customer_name.id,
                ),
            )
        }

        // Site filter
        if (sitesQuery) {
            const siteIdsSplit = queryIntoArrayNumber(sitesQuery)

            allPlanogramsFiltered = allPlanogramsFiltered.filter((planogram) =>
                siteIdsSplit.includes(planogram.machine.site.id),
            )
        }

        // Machine type filter
        if (machineTypeQuery) {
            const machineTypeSplit = machineTypeQuery.split(',')

            allPlanogramsFiltered = allPlanogramsFiltered.filter((planogram) =>
                machineTypeSplit.includes(planogram.machine.category),
            )
        }

        // Name filter
        if (nameQuery) {
            allPlanogramsFiltered = allPlanogramsFiltered.filter((planogram) =>
                planogram.name.toLowerCase().includes(nameQuery.toLowerCase()),
            )
        }

        // Status filter
        if (statusQuery) {
            allPlanogramsFiltered = allPlanogramsFiltered.filter(
                (planogram) => planogram.status === statusQuery,
            )
        }

        // Pagination
        const limit = isNumeric(limitQuery) ? Number(limitQuery) : 10
        const offset = isNumeric(offsetQuery) ? Number(offsetQuery) : 0

        const limitArray =
            allPlanogramsFiltered.length > limit
                ? offset + limit
                : allPlanogramsFiltered.length

        const results = allPlanogramsFiltered.slice(offset, limitArray)

        const next =
            offset + results.length < allPlanogramsFiltered.length
                ? 'again'
                : undefined

        return HttpResponse.json({
            next,
            results,
        })
    },
)
